// ##EntryHandle The handle a queued-edits Bundle entry is reported under —
// the single scheme shared by intents, decisions, groups, and the review UI so
// they all key the same entry by one value. For a mutation (PATCH/PUT/DELETE) that is the
// target `ResourceType/id`, i.e. `request.url`; a POST create has no resolved id
// yet, so it falls back to the `urn:uuid` fullUrl. A generator that stamps
// per-entry intents must derive its keys with this function, or the keys drift
// from what `matchesHandle` accepts at lookup time.

import type { BundleEntry } from '@medplum/fhirtypes'

export function entryHandle(entry: BundleEntry): string | undefined {
  const method = entry.request?.method
  if (method && method !== 'POST') {
    return entry.request?.url ?? entry.fullUrl
  }
  return entry.fullUrl ?? entry.request?.url
}

// Whether an entry is the one a given handle refers to. Accepts either form
// (`request.url` or `fullUrl`) so callers may look up by whichever they hold.
export function matchesHandle(entry: BundleEntry, handle: string): boolean {
  return entry.fullUrl === handle || entry.request?.url === handle
}
